/*global require,module*/
(function commonJS(require, module) {
  'use strict';

  require('./dist/angular-tooltips');

  module.exports = '720kb.tooltips';
}(require, module));



//////////////////
// WEBPACK FOOTER
// ./~/angular-tooltips/index.js
// module id = 333
// module chunks = 0